// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import translation files
import translationEN from './locales/ENtranslation.json';
import translationSL from './locales/SLtranslation.json';

i18n
  .use(initReactI18next)  // Tells i18next to use React's i18next wrapper
  .init({
    resources: {
      en: { translation: translationEN },
      sl: { translation: translationSL },
    },
    lng: 'sl', // Default language is Slovenian
    fallbackLng: 'en',  // Fallback language if a translation is missing
    interpolation: {
      escapeValue: false,  // React already escapes variables
    },
  });

export default i18n;
